import * as requests from "../../coraWebComponents/utils/requests";
import urls from "../../constants/Urls";

const buildZP_C_TYP_PRACE = () => {
  return `${urls.ZP_C_TYP_PRACE}`;
};

export const getZP_C_TYP_PRACE = async () => {
  const url = buildZP_C_TYP_PRACE();
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};
